export default __webpack_public_path__ + "static/media/elon.f63231e5.png";